import { render } from "./ContactMe.vue?vue&type=template&id=5b0ed578&scoped=true&ts=true"
import script from "./ContactMe.vue?vue&type=script&lang=ts"
export * from "./ContactMe.vue?vue&type=script&lang=ts"

import "./ContactMe.vue?vue&type=style&index=0&id=5b0ed578&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b0ed578"]])

export default __exports__